import { List, fromJS } from 'immutable';

export function request(state, { userId, bet }) {
    state = state.set(
        'bets',
        state.get('bets').set(
            userId,
            (state.getIn([ 'bets', userId ]) || List()).push(fromJS(bet))
        )
    );

    return state;
}
